import { Typography } from '@components/common/Typography';
import styled from 'styled-components';
import { InfoWrapper } from '@components/common/Tooltip.styles';

export const OptionContainer = styled.div<{ selected?: boolean; isDropdownOpen?: boolean }>`
  width: 100%;
  cursor: pointer;
  height: 76px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1.4rem;
  align-items: center;
  :hover {
    background-color: ${({
      theme: {
        colors: {
          primary: { lightestMore },
        },
      },
    }) => lightestMore};
  }

  ${({
    selected,
    theme: {
      colors: {
        functional: { white },
      },
    },
  }) =>
    selected &&
    `
      :hover{
        background-color: ${white};
      }
  `};
`;

export const IconAndLabel = styled.div`
  display: flex;
  white-space: initial;
  width: 100%;
`;

export const IconContainer = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 9999px;
  img,
  svg {
    width: 24px;
  }
`;

export const Label = styled(Typography)`
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  color: ${({
    theme: {
      colors: {
        functional: { darkestGray },
      },
    },
  }) => darkestGray};
  font-size: 16px;
  line-height: 21px;
  font-weight: 700;
  margin-left: 4px;
  word-wrap: break-word;
`;

export const DescriptionContainer = styled.div<{ withPaddingLeft?: boolean }>`
  width: 100%;
  ${({ withPaddingLeft }) => withPaddingLeft && `padding-left: 2.4rem;`}
`;

export const Description = styled(Label)`
  color: ${({
    theme: {
      colors: {
        functional: { darkGray },
      },
    },
  }) => darkGray};
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
`;
